// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___2xI8I","marginLeft":"styles__marginLeft___3yWVE","marginRight":"styles__marginRight___LYVzb"};